module.exports = {
    "xspace.client.xform.XImage.xeditorUploadImageImage": "上传图像",
    "xspace.client.xform.XImage.xeditorXImageAlign": "对齐",
    "xspace.client.xform.XImage.xeditorXImageDeleteImage": "删除图像",
    "xspace.client.xform.XImage.xeditorXImageDownloadImage": "下载图像",
    "xspace.client.xform.XImage.xeditorXImageImage": "图像",
    "xspace.client.xform.XImage.xeditorXImageLeftAlign": "向左浮动",
    "xspace.client.xform.XImage.xeditorXImageNofloat": "中心",
    "xspace.client.xform.XImage.xeditorXImageReplaceImage": "替换图像",
    "xspace.client.xform.XImage.xeditorXImageRestoreWidth": "恢复原尺寸",
    "xspace.client.xform.XImage.xeditorXImageRightAlign": "向右浮动",
    "xspace.client.xform.dateRange.xformDefaultEndDatePlaceholder": "结束日期",
    "xspace.client.xform.dateRange.xformDefaultStartDatePlaceholder": "开始日期",
    "xspace.client.xform.index.xformDefaultSubmitButtonLabel": "提交",
    "xspace.client.xform.index.xformUploaderErrorStatusCheckMessage": "图片/文件上传失败，请重新上传后再提交",
    "xspace.client.xform.index.xformUploaderImageFileCheckMessage": "上传的不是图片类型文件，请重新上传图片",
    "xspace.client.xform.index.xformUploaderUploadingStatusCheckMessage": "图片/文件上传中，请稍后提交",
    "xspace.client.xform.insertbar.xeditorInsertbarMenuTitle": "插入",
    "xspace.client.xform.insertbar.xeditorInsertbarTool": "工具",
    "xspace.client.xform.multiSelect.xformCheckAllLabel": "全选",
    "xspace.client.xform.upload.xformBatchUploadDefaultLabel": "上传",
    "xspace.client.xform.upload.xformBatchUploadToolTip": "ctrl/command键可批量上传",
    "xspace.client.xform.upload.xformExampleImageLabel": "示例图片",
    "xspace.client.xform.upload.xformFileTemplateLabel": "模板",
    "xspace.client.xform.upload.xformMaxFileNumErrorTip": "上传文件超出最大限制",
    "xspace.client.xform.upload.xformMaxFileSizeErrorTip": "超出文件大小最大限制：",
    "xspace.client.xform.upload.xformUploadErrorTip": "上传失败，请稍后重试."
};